export default function removeHostFromUrl(url) {
  const { protocol, host } = window.location;

  return url.replace(`${ protocol }//${ host }`, '');
}
